import { fetchWrapper } from "../utils/fetch-wrapper";

const societesService = {
  getAll,
  getById,
  getAllClient,
  post,
  delete: _delete,
  update,
};

function getAll(env_client_id: any = "") {
  const queryParams: Record<string, any> = {};

  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }
  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");
  return fetchWrapper.get(`societes/?${queryString}`);
}

function getAllClient(client_id: number) {
  return fetchWrapper.get(`societes/client/${client_id}`);
}

function getById(id) {
  return fetchWrapper.get(`societes/${id}`);
}

function post(data) {
  return fetchWrapper.post("societes/", data);
}

function update(id, params) {
  return fetchWrapper.put(`societes/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`societes/${id}`);
}

export default societesService;
